<template>
<div class="lvImgTextBox">

  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
        <div v-for="(item, index) in words">
          <lvImgTextItem :time="item.time" :text="item.content" :imgUrl="item.image"></lvImgTextItem>
        </div>
    </van-list>
  </van-pull-refresh>
</div>
</template>

<script>
import {apiLive} from "../../../network/app/apiPlatformLive";
import lvImgTextItem from "./lvImgTextItem";
export default {
  name: "lvImgText",
  components:{
    lvImgTextItem
  },
  props: {
    isAction: {
      type: Boolean,
      default: false,
    },
    baseInfo: {
      type: Object,
      required: true
    },
  },
  watch:{
    isAction: {
      handler(newVal,oldVal) {
        if((newVal)&&(this.firstAct)){
          this.firstAct = false
          // 第一次激活
          // 获取图文信息
          // console.log("第一次激活 获取图文信息")
          this.getPlatformLiveWordsPullUP(true)
        }
      },
    }
  },
  updated() {
    // console.log(window.document.body.parentElement.scrollHeight)
  },
  created() {
    // 创建定时器10s
    this.timer = setInterval(this.intervalCallBack, 20000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  data(){
    return {
      //下拉
      refreshing: false,

      firstAct: true,

      loading: false,
      finished: true,

      words: [],
      refreshTime: 0,    //刷新用，传最新一条文字time字段 毫秒  (bigInteger)
      lastTime: 0,    //上拉加载用，传最后一条文字time字段 毫秒  (bigInteger)

      limitMax: 6,

      //定时器
      timer: '',
    }
  },
  methods:{
    intervalCallBack(){
      if(this.isAction){
        this.getPlatformLiveWordsPullDown();
      }
    },

    getPlatformLiveWordsPullDown(){
      // console.log("下拉")
      let obj = {
        'id': this.baseInfo.id,
        'limit': this.limitMax,
      }

      if(this.words.length!=0){
        obj.refreshTime = this.words[0].time
      }

      apiLive.getPlatformLiveWords(obj).then(res=>{

        for (let i=0; i<res.words.length; i++){
          this.words.unshift(res.words[res.words.length-1-i])
        }
        if((this.words.length!=0)){
          this.lastTime = this.words[this.words.length-1].time
          // console.log('第N次请求更新时间'+this.lastTime)
        }
        // console.log((res))
        this.refreshing = false;
      }).catch(err=>{
        this.refreshing = false;
      })
    },

    getPlatformLiveWordsPullUP(isFirst = false){
      let obj = {
        'id': this.baseInfo.id,
        'limit': this.limitMax,
      }

      if(isFirst==true){
        this.words.length = 0
        var curData = new Date();
        var curTick = parseInt(curData.getTime()/1000)
        obj.lastTime = curTick
        // console.log('第1次请求时间'+obj.lastTime)
      }else{
        // console.log('第N次请求时间'+this.lastTime)
        obj.lastTime = this.lastTime
      }

      apiLive.getPlatformLiveWords(obj).then(res=>{

        for (let i=0; i<res.words.length; i++){
          this.words.push(res.words[i])
        }
        if((this.words.length!=0)){
          this.lastTime = this.words[this.words.length-1].time
          // console.log('第N次请求更新时间'+this.lastTime)

          if(isFirst==true){
            this.refreshTime = res.words[0].time
          }
        }
        // console.log((res))
        if(res.words.length<this.limitMax){
          // console.log('上拉获取结束')
          this.finished = true;
        }else{
          // console.log('上拉获取还有更多数据')
          this.finished = false;
        }
        this.loading = false;
      }).catch(err=>{
        this.loading = false;
        this.finished = true;
      })
    },

    onLoad(){
      this.getPlatformLiveWordsPullUP()


      return;

        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        // setTimeout(() => {
        //   for (let i = 0; i < 10; i++) {
        //     this.list.push(this.list.length + 1);
        //   }
        //
        //   // 加载状态结束
        //   this.loading = false;
        //
        //   // 数据全部加载完成
        //   if (this.list.length >= 100) {
        //     this.finished = true;
        //   }
        // }, 1000);
    },
    onRefresh(){
      this.getPlatformLiveWordsPullDown()
    }
  }
}
</script>

<style scoped>
.lvImgTextBox{
  position: relative;
  margin-left: -45px;
  width: 1080px;
}
</style>